import { classNames } from '@dimjs/utils';
import { CSSProperties, FC } from 'react';
import { generateIntArray } from '../utils/generate-int-array';
import './style.less';

export type SkeletonProps = {
  className?: string;
  style?: CSSProperties;
  animated?: boolean;
};

export type SkeletonParagraph = SkeletonProps & {
  lineCount?: number;
};

const classPrefix = 'v-skeleton';

export const Skeleton = (props: SkeletonProps) => {
  return (
    <div
      className={classNames(
        classPrefix,
        {
          [`${classPrefix}-animated`]: props.animated,
        },
        props.className,
      )}
    />
  );
};

export const SkeletonTitle = (props: SkeletonProps) => {
  return <Skeleton animated={props.animated} className={`${classPrefix}-title`} />;
};

export const SkeletonParagraph: FC<SkeletonParagraph> = (props) => {
  const keys = generateIntArray(1, props.lineCount as number);
  return (
    <div className={`${classPrefix}-paragraph`} style={props.style}>
      {keys.map((key) => (
        <Skeleton key={key} animated={props.animated} className={`${classPrefix}-paragraph-line`} />
      ))}
    </div>
  );
};

Skeleton.defaultProps = {
  animated: true,
};

SkeletonParagraph.defaultProps = {
  lineCount: 5,
};
